import { useEffect } from 'react';
import { trackRentalRequestPageView } from '@/lib/tracking/tjvrPageTracking';

type UseRentalRequestTrackingProps = {
    adId: number;
    isOwner: boolean;
};

export const useRentalRequestTracking = ({ adId, isOwner }: UseRentalRequestTrackingProps) => {
    useEffect(() => {
        trackRentalRequestPageView(adId, isOwner);
    }, [adId, isOwner]);
};
